import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

interface AnimationTarget {
  current: HTMLElement | null;
}

/**
 * Animates the section title with a fade-in and slide-up effect
 */
export const animateTitle = (
  titleRef: AnimationTarget,
  sectionRef: AnimationTarget,
  delay: number = 0
): void => {
  if (!titleRef.current || !sectionRef.current) return;

  gsap.fromTo(
    titleRef.current,
    { opacity: 0, y: 20 },
    {
      opacity: 1,
      y: 0,
      duration: 0.7,
      delay,
      ease: "power3.out",
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 75%",
        once: true,
      },
    }
  );
};

/**
 * Animates the terms content with a staggered fade-in effect
 */
export const animateContent = (
  contentRef: AnimationTarget,
  sectionRef: AnimationTarget,
  delay: number = 0.3
): void => {
  if (!contentRef.current || !sectionRef.current) return;

  // Get all paragraphs and headings within the content
  const elements = contentRef.current.querySelectorAll("p, h2, h3, h4, ul, ol");

  gsap.fromTo(
    elements,
    { opacity: 0, y: 15 },
    {
      opacity: 1,
      y: 0,
      duration: 0.6,
      stagger: 0.1,
      delay,
      ease: "power2.out",
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 70%",
        once: true,
      },
    }
  );
};

/**
 * Cleans up all ScrollTrigger instances
 */
export const cleanupScrollTriggers = (): void => {
  ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
};
